import { render, staticRenderFns } from "./PaTrend.vue?vue&type=template&id=517d6b43&scoped=true"
import script from "./PaTrend.vue?vue&type=script&lang=js"
export * from "./PaTrend.vue?vue&type=script&lang=js"
import style0 from "./PaTrend.vue?vue&type=style&index=0&id=517d6b43&prod&lang=css"
import style1 from "./PaTrend.vue?vue&type=style&index=1&id=517d6b43&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "517d6b43",
  null
  
)

export default component.exports